import AppointmentPreviewApp from "../preview/AppointmentPreviewApp";
import { t } from "i18next";
import { Button, Tooltip } from "antd";
import React from "react";
import { useDataGrid } from "../../../core/components/data-grid/DataGridContext";
import { useModal } from "../../../core/context/ModalContext";
import { PERMISSIONS, useUser } from "../../../core/context/UserContext";
import AppLink from "../../../core/components/AppLink";

function useCanOpenAppointment(row) {
    const { hasPermission, user } = useUser();
    return hasPermission(PERMISSIONS.APPOINTMENT_VIEW_OTHER_USER) || row?.responsibleUserId == user?.id;
}

/**
 * Hücre içeriğini randevu sayfasına link yapar (hasta adı, tarih vb.).
 * Yetki yoksa içerik düz metin olarak kalır.
 */
export function AppointmentLink({ row, children }) {
    const canOpen = useCanOpenAppointment(row);

    if (!canOpen) return children;

    return (
        <AppLink
            to={`/app/patients/${row?.patientId}/appointments/${row?.appointmentId}`}
            style={{ display: 'inline-block' }}
        >
            {children}
        </AppLink>
    )
}

/** #{id} — tıklanınca randevu önizlemesini açar. */
export default function AppointmentIdColumn({ text, row, onSelect }) {
    const { refreshDataGrid } = useDataGrid()
    const { openModal } = useModal()
    const canOpen = useCanOpenAppointment(row);

    const openPreview = () => {
        openModal(
            t("Appointment Preview"),
            <AppointmentPreviewApp appointmentId={row.appointmentId} onDelete={() => { refreshDataGrid() }} />,
            () => refreshDataGrid()
        )
    }

    const link = (
        <Button
            size="small"
            style={{ minWidth: 64 }}
            disabled={!canOpen}
            onClick={() => onSelect ? onSelect(row) : openPreview()}
        >
            #{row.appointmentId}
        </Button>
    )

    return canOpen ? <Tooltip title={t('Preview')}>{link}</Tooltip> : link
}
